module.exports = __webpack_public_path__ + "fonts/effect-resist-physical-137a25.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-resist-physical.svg
// module id = 819
// module chunks = 0